module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol.js
// module id = 1370
// module chunks = 0